import React from 'react';
import PropTypes from 'prop-types';
import './topNotificationMessage.less';

const TopNotificationMessage = (props) => {
  const { message, visible, warning } = props;

  return (
    <div className={`top-notification-message ${visible ? 'show' : ''} ${warning ? 'warning' : 'danger'}`}>
      <span className="info-message">
        {message}
      </span>
    </div>
  );
};

TopNotificationMessage.propTypes = {
  message: PropTypes.node.isRequired,
  visible: PropTypes.bool,
  warning: PropTypes.bool
};

export default TopNotificationMessage;
